import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import styles from "../../../assets/json/styles.json";
// import portData13 from "../../../assets/json/vessel_details_8feb_11am.json";
import { approvalService } from 'src/app/services/approval.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { trailService } from 'src/app/services/trail.service';

interface TRAIL{
    data,
    metadata
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements AfterViewInit,OnInit {
  // @Inject(MAT_DIALOG_DATA) public data: AddSubTaskDialogData {
  //   this.id = data.subtaskID;
  // }

  User;
  lat = 29.756068;
  lng = -95.060537;
  markerLat;
  markerLong;
  // color;
  // rot;
  style = styles;
  id: any;
  latlng = [];
  zoom = 1;
  userLocationMarkerAnimation: string;
  mmsi;
  configUrl="https://supplyforecasting.stoltdev.think360.ai/api/get/ship/trail/";
  trailData;
  ship;
  filtered;
  metadata;
  currentD:any;

  
  countryRestriction = {
    latLngBounds: {
      north: 85.0,
      south: -85.0,
      west: -180.0,
      east: 180.0
    },
    strictBounds: true
  };

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>, private appService: approvalService,private trailService: trailService, private http: HttpClient, private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.appService.currentApprovalStageMessage.subscribe(data => this.User = data);
    // this.id = data.id;
    this.markerLat = data.lat;
    this.markerLong = data.lng;
    // this.color = data.color;
    // this.rot = data.rot;
    this.mmsi = data.mmsi;
    // this.getTrailData();
    // this.trailService.currentApprovalStageMessage.subscribe((data:any) => this.metadata=data.metadata);
    setTimeout(() => {
      // this.trailService.currentApprovalStageMessage.subscribe((data:any) => this.metadata=data.metadata);
      this.trailService.currentApprovalStageMessage.subscribe((data:any) =>{ 
        this.metadata=data.metadata
        this.trailData=data.data;
        for(let i=0; i<this.trailData?.length; i++){
          this.trailData[i]["arrivalTime"] = this.metadata.port_timings[i].arrival_time;
          this.trailData[i]["departureTime"] = this.metadata.port_timings[i].departure_time;
        }
        
      })
      // this.trailService.currentApprovalStageMessage.subscribe((data:any) => this.metadata=data.metadata);
    }, 1000); 
    console.log(this.trailData);
    console.log(this.metadata);
    this.ship = data.ship;
    this.clickedMarker(this.mmsi);

    // let queryParams = this.mmsi;
    //   this.http.get(this.configUrl,{params:queryParams}).subscribe((resp: any) => this.trailData = resp.data)
    // console.log(this.trailData)
  }


  close(): void {
    this.dialogRef.close();
    this.zoom = 1;
  }
  ngAfterViewInit(): void {
    // this.trailService.currentApprovalStageMessage.subscribe((data:any) => this.metadata=data.metadata);
    // for(let i=0; i<this.trailData?.length; i++){
    //   this.trailData[i]["arrivalTime"] = this.metadata.port_timings[i].arrival_time;
    //   this.trailData[i]["departureTime"] = this.metadata.port_timings[i].departure_time;
    // }
      // console.log(somedata)
      console.log(this.trailData)
    // this.appService.currentApprovalStageMessage.subscribe(data => this.User = data);


     this.filtered =this.User.filter(
      m=> m.mmsid == this.mmsi
    )
    this.cdr.detectChanges();
    console.log(this.filtered);
    this.dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close();
      // let data = portData13.filter(
      //   m=> new Date(m.Laycan_datetime_UTC_) >= new Date("01/01/2022")
      // )
      // this.appService.updateApprovalMessage(data);
    })
    
    // this.cdr.detectChanges();
    console.log("ada",this.trailData);
    
  }

  objectKeys(obj) {
    return Object.keys(obj);
}

  getTrailData(){
    this.trailService.fetchData(this.mmsi)
  .subscribe((data:any) => {
    this.trailData = data.data;
    this.metadata  = data.metadata;
    this.trailService.updateApprovalMessage(data);
  });
  console.log(this.trailData);
  }

  clickedMarker(id) {
    console.log(id,this.trailData);

  }

  mapReading() {
    this.userLocationMarkerAnimation = 'BOUNCE';
  }

  ngOnInit(){
    // this.trailService.currentApprovalStageMessage.subscribe((data:any) => this.trailData=data.data);
    // this.trailService.currentApprovalStageMessage.subscribe((data:any) => this.metadata=data.metadata);
    // // this.currentD = this.trailData[length-1].draught;
    // for(let i=0; i<this.trailData?.length; i++){
    //   this.currentD = this.trailData[length-1].draught;
    //   console.log(this.trailData?.length)
    // }
  }

  ngOnDestroy() {
    console.log("diadestroy");
    
    this.trailData.unsubscribe();
    this.metadata.unsubscribe();
}
}